<template>
  <!--==========================
    Contact Section
  ============================-->
  <section id="contact">
    <div class="container">
      <!-- Section Header -->
      <div class="section-header text-center mb-5">
        <div class="row justify-content-center">
          <div class="col-lg-8 col-md-10">
            <h3 class="section-title">Contact</h3>
            <p>
              If you'd like to contact me about your business and see what I can do
              to help then please send an email and I'll get back to you as soon as
              possible.
            </p>
          </div>
        </div>
      </div>

      <!-- Contact Info -->
      <div class="row justify-content-center mt-5">
        <div class="col-lg-3 col-md-4">

          <div class="info mb-4">
            <div class="mb-3 d-flex align-items-start">
             <div class="icon mb-3"><i><font-awesome-icon icon="map-marker-alt" /></i></div>
              <p>
                10 Tavern Gardens,<br />
                Weare Giffard,<br />
                Bideford,<br />
                Devon,<br />
                EX39 4QR
              </p>
            </div>

            <div class="mb-3 d-flex align-items-center">
              <div class="icon mb-3"><i><font-awesome-icon icon="envelope" /></i></div>
              <p>
                <a href="mailto:richard@rmsoftwareservices.co.uk">richard@rmsoftwareservices.co.uk</a>
              </p>
            </div>

            <div class="mb-3 d-flex align-items-center">
              <div class="icon mb-3"><i><font-awesome-icon icon="phone" /></i></div>
              <p>01237 725206</p>
            </div>
          </div>

          <!-- Social Links -->
          <div class="social-links d-flex gap-3">
            <a href="https://www.linkedin.com/in/richard-moulton-a905133a/" target="_blank" rel="noopener">
              <i><font-awesome-icon icon="fa-brands fa-linkedin-in" /></i>
            </a>
            <a href="https://github.com/richardm90" target="_blank" rel="noopener">
              <i><font-awesome-icon icon="fa-brands fa-github" /></i>
            </a>
          </div>

        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "ContactSection",
};
</script>
